export const environment = {
  production: true,
  appConfigFile: './app-config.stg.json',
  firebaseConfig: {
    apiKey: 'AIzaSyCMjRxpwlZvjwdcRa0YcDS0A-n6qILT_0I',
    authDomain: 'elleven-staging.firebaseapp.com',
    databaseURL: 'https://elleven-staging.firebaseio.com',
    projectId: 'elleven-staging',
    storageBucket: 'elleven-staging.appspot.com',
    messagingSenderId: '93285524713',
    appId: '1:93285524713:web:7963dbd975f5365d373c78',
    measurementId: 'G-3Z4846LW8Q'
  }
};
